import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { useDeferredCompassModalClose } from "@circle-react/components/QuickPostV3/hooks/useDeferredCompassModalClose";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { CompassConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal/CompassConfirmationModal";

interface DiscardChangesModalProps {
  onConfirm: () => void;
  onDiscardChanges?: () => void;
}

const I18N_ROOT = "quick_post_v3.discard_changes";

const DiscardChangesModalComponent = ({
  onDiscardChanges,
  onConfirm,
}: DiscardChangesModalProps) => {
  const { isOpen, hide: closeModal } = useDeferredCompassModalClose();

  const handleConfirm = () => {
    onDiscardChanges?.();
    onConfirm();
    closeModal();
  };

  return (
    <CompassConfirmationModal
      isOpen={isOpen}
      onClose={closeModal}
      onCancel={closeModal}
      onConfirm={handleConfirm}
      size="sm"
      title={t([I18N_ROOT, "title"])}
      confirmText={t([I18N_ROOT, "confirm"])}
      confirmVariant="danger"
    >
      <Typography variant="body-sm">{t([I18N_ROOT, "description"])}</Typography>
    </CompassConfirmationModal>
  );
};

const DiscardChangesModal = ModalManager.create(
  (props: DiscardChangesModalProps) => (
    <DiscardChangesModalComponent {...props} />
  ),
);

export const useDiscardChangesModal = () => useModal(DiscardChangesModal);
